module.exports = __webpack_public_path__ + "img/mastercard.bf1e2451.png";